import styled, { createGlobalStyle } from 'styled-components';
import { Radio } from '@mui/material';
import Switch from '@mui/material/Switch';
import { styled as muiStyled } from '@mui/material/styles';
import { OverviewCardInfo }  from '../Marketing.styled'
import {OverviewContainer} from "../Marketing.styled";


const AdvancedSettingsCardInfo = styled(OverviewCardInfo)`
  > div {
    display: flex;
    justify-content: flex-start;
  }
`

const BoxLabel = styled.span`
  display: flex;
  gap: 5px;
  font-weight: 600;
  font-size: 0.875rem;
  order: ${(props) => props.order ? props.order : 0};
`;

const HumanWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-family: ${(props) => props.theme.fonts.family.inter};

  & > div {
    gap: 8px;
  }

  .contactOwner {
    order:0;
  }

  .roundRobin {
    order:1;
  }

  .assignUser {
    order:2;
  }

  .defaultUser {
    order:3;
  }


`;

const UserSelectorWrapper = styled.div`
  display: flex;
  max-width: 400px;

  & > div:nth-child(1) > div:nth-child(4) {
    width: ${(props) => (props.isMobile ? "290px" : "534px")};
  }
`;

const CustomSelectorWrapper = styled.div`
  padding: 1rem;
  border: 1px solid ${(props) => props.theme.colors.clearGray};
  border-radius: 0.8rem ;
`;

const AssignmentContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
`;

export const StyledRadio = muiStyled(Radio)({
  '&.MuiRadio-root': {
    color: '#CBD5E1',
    padding: '8px',
  },
  '&.Mui-checked': {
    color: '#3B82F6',
  },
  '&:hover': {
    backgroundColor: 'rgba(59, 130, 246, 0.04)',
  },
});

const StyledSwitch = muiStyled(Switch)({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: "#000",
  },

  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: '#2173ff',
    opacity: 1,
  },

  '& .MuiSwitch-switchBase.Mui-checked > .MuiSwitch-thumb':{
    backgroundColor: '#ffffff'
  }
});

const RadioWrapper = styled.div`
  display: flex;
  align-items: center;
  order:0;

  .MuiFormControlLabel-root {
    margin: 0;
  }
`;

const ContactOwnerWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-items: flex-start;
  font-size: 10px;
  font-weight: 300;
  color: ${(props) => props.theme.colors.greyEleven};
  padding: 0 10px;

  .simple-card-container {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    flex-direction: row;
  }
`;

const CustomGenericListStyle = createGlobalStyle`
  .advanced-settings{
    padding-inline-end: 0px;
  }
`

const RoundRobinWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const RoundRobinSwitchesContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap:24px;
`

const BoxHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  width: 100%;
  order: 2;
`;

const BoxQty = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-direction: row;
  font-size: 14px;
  font-weight: 600;
  color: ${(props) => props.theme.colors.mountainMist};
`;

const AdvancedSettingsContainer = styled(OverviewContainer)`
    overflow-y: auto;
`;

export {
  AdvancedSettingsCardInfo,
  BoxLabel,
  HumanWrapper,
  UserSelectorWrapper,
  CustomSelectorWrapper,
  AssignmentContainer,
  CustomGenericListStyle,
  ContactOwnerWrapper,
  RadioWrapper,
  StyledSwitch,
  RoundRobinWrapper,
  RoundRobinSwitchesContainer,
  BoxHeader,
  BoxQty,
  AdvancedSettingsContainer
};